<template>
  <footer class="footer px-4">
    <div class="row align-items-center justify-content-lg-between">
      <div class="col-lg-6">
        <div class="copyright text-center text-lg-left text-muted">
          © {{year}} <a href="https://www.resimple.com.ar" class="font-weight-bold ml-1 rslink" target="_blank">Resimple SA</a>
        </div>
      </div>
      <div class="col-lg-12">Último acceso: {{$store.getters.LastEntryDate.substring(8, 10)}}-{{$store.getters.LastEntryDate.substring(5, 7)}}-{{$store.getters.LastEntryDate.substring(0, 4)}} - {{$store.getters.LastEntryDate.substring(11, 16)}} hs.</div>
      <div class="col-lg-6">
        <ul class="nav nav-footer justify-content-center justify-content-lg-end">
          <li class="nav-item">
            <a href="https://www.resimple.com.ar" class="nav-link" target="_blank">Resimple</a>
          </li>
          <li class="nav-item">
            <a href="https://www.resimple.com.ar/legales" class="nav-link" target="_blank">Términos y condiciones</a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
